import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const AttendanceInputPermission = lazy(() => import('../../container/attendanceInputPermission/AttendanceInputAccess'));
const AllowUserAttendanceInput = lazy(() => import('../../container/attendanceInputPermission/allowUserAttendanceInput'));

const AttendanceInputPermissionRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/attendanceInputPermission`} component={AttendanceInputPermission}/>
            <Route path={`${path}/allowUserAttendanceInput`} component={AllowUserAttendanceInput}/>
        </Switch>
    );
};

export default AttendanceInputPermissionRoutes;